<template>
  <ul class="v-breadcrumbs"
      :class="[classes]"
  >
    <v-breadcrumbs-item v-for="item in items" :key="item.text" :item="item">
      {{ item.text }}
    </v-breadcrumbs-item>
  </ul>
</template>

<script>

export default {
  name: 'VBreadcrumbs',
  props: {
    items: {
      type: Array,
    },
    large: Boolean,
  },
  computed: {
    classes() {
      return {
        'v-breadcrumbs--large': this.large,
      }
    },
  }
};
</script>

<style lang="scss">
@import "VBreadcrumbs";
</style>
